module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.offers.length) ? _c('div', {
    staticClass: "offers-list"
  }, [_c('div', {
    staticClass: "offer-items"
  }, _vm._l((_vm.offers), function(offer) {
    return _c('offer-slot', {
      key: offer.id,
      attrs: {
        "rules": offer.getAvailableDaysAndTimes(),
        "title": offer.name,
        "description": offer.description,
        "validFrom": offer.validFrom ? _vm.DateService.friendlyDate(offer.validFrom) : null,
        "validTo": offer.validTo ? _vm.DateService.friendlyDate(offer.validTo) : null,
        "minPax": offer.minimumPeople,
        "maxPax": offer.maximumPeople,
        "offer": offer
      }
    })
  }))]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c152a60c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/offersList.vue
// module id = 615
// module chunks = 0